import { useGSAP, useGSAPConfig } from '@gsap/react'
import gsap from 'gsap'

import { MediaQuery } from '@/constants'

export type MatchMediaContext = Partial<{
  // eslint-disable-next-line no-unused-vars
  small: (context: gsap.Context) => void
  // eslint-disable-next-line no-unused-vars
  medium: (context: gsap.Context) => void
  // eslint-disable-next-line no-unused-vars
  large: (context: gsap.Context) => void
  revert: () => void
}>

export const useMotionMatchMedia = (
  { small, medium, large, revert }: MatchMediaContext,
  dependencies?: unknown[] | useGSAPConfig
) => {
  useGSAP(() => {
    const matchMedia = gsap.matchMedia().add(
      {
        isSmall: MediaQuery.SMALL,
        isMedium: MediaQuery.MEDIUM,
        isLarge: MediaQuery.LARGE
      },
      (context) => {
        const { isSmall, isMedium, isLarge } = context.conditions as gsap.Conditions
        // console.log({ isSmall, isMedium, isLarge })

        if (isSmall) {
          small?.(context)
        }

        if (isMedium || isLarge) {
          medium?.(context)
        }

        if (isLarge) {
          large?.(context)
        }

        return () => {
          revert?.()
        }
      }
    )

    return () => {
      matchMedia.revert()
    }
  }, dependencies)
}
